const ForecastFilters = ({ onChange }) => {
  return (
    <div className="d-flex gap-3 mb-3">
      <select
        className="form-control"
        onChange={(e) => onChange({ days: e.target.value })}
      >
        <option value="7">7 Days</option>
        <option value="30">30 Days</option>
        <option value="90">90 Days</option>
      </select>
    </div>
  );
};

export default ForecastFilters;
